export const globalGetters = {
  healthPlans: 'healthPlan/healthPlans'
}

export const getters = {
  healthPlans: state => state.healthPlans
}
